import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
// Services Firebase
import { storage, db } from "../../firebase.js";
import { getDownloadURL, ref, uploadBytes, deleteObject } from "firebase/storage";
import { doc, getDoc, updateDoc } from "firebase/firestore";

function CreateVideo() {
  const navigate = useNavigate();

  // Estados de inputs
  const [linkInput, setLinkInput] = useState("");
  const [titleInput, setTitleInput] = useState("");
  const [djInput, setDjInput] = useState("");
  const [pictureURL, setPictureUrl] = useState("");
  const [videos, setVideos] = useState([]);

  // Estados de UI
  const [errorMessage, setErrorMessage] = useState("");
  const [isLoadingPicture, setIsLoadingPicture] = useState(false);
  const [isFetching, setIsFetching] = useState(true);

  const listVideosId = "65Qp6eNY3w7MWdTneNXM";

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    try {
      const getVideos = doc(db, "videosLaLista", listVideosId);
      const videosById = await getDoc(getVideos);
      setVideos(videosById.data().videos);
      setIsFetching(false);
    } catch (error) {
      console.log("Error cargando videos:", error);
    }
  };

  const handleVideoLinkChange = (e) => setLinkInput(e.target.value);
  const handleVideoTitleChange = (e) => setTitleInput(e.target.value);
  const handleVideoDjChange = (e) => setDjInput(e.target.value);

  const handlePictureChange = async (e) => {
    setIsLoadingPicture(true);
    const image = e.target.files[0];
    try {
      const storageRef = ref(storage, `images/${image.name}`);
      const snapShot = await uploadBytes(storageRef, image);
      const downloadUrl = await getDownloadURL(snapShot.ref);
      setPictureUrl(downloadUrl);
      setIsLoadingPicture(false);
    } catch (error) {
      navigate("/error");
    }
  };

  // 🔹 Función para limpiar el link de YouTube y quedarnos solo con el ID
  const extractYoutubeId = (url) => {
    try {
      const urlObj = new URL(url);
      return urlObj.searchParams.get("v"); // devuelve el valor de ?v=
    } catch (error) {
      return null;
    }
  };

  // 🔹 Función para sacar el path real desde la URL de Firebase Storage
  const getStoragePathFromUrl = (url) => {
    const start = url.indexOf("/o/") + 3;
    const end = url.indexOf("?");
    const pathEncoded = url.substring(start, end);
    return decodeURIComponent(pathEncoded); // images%2Fpic.jpg → images/pic.jpg
  };

  const handleCreateVideo = async (e) => {
    e.preventDefault();
    const videosToUpdate = [...videos];

    // Extraer ID del link
    const videoId = extractYoutubeId(linkInput);

    if (!videoId) {
      setErrorMessage("El link de YouTube no es válido");
      return;
    }

    const newVideo = {
      link: `https://www.youtube.com/embed/${videoId}`,
      title: titleInput,
      dj: djInput,
      picture: pictureURL,
    };

    try {
      // Si hay 6 vídeos, eliminamos el último (posición 5)
      if (videosToUpdate.length >= 6) {
        const oldVideo = videosToUpdate[5];
        if (oldVideo.picture) {
          try {
            const picturePath = getStoragePathFromUrl(oldVideo.picture);
            const pictureRef = ref(storage, picturePath);
            await deleteObject(pictureRef);
            console.log(`Imagen del vídeo antiguo eliminada del Storage ✅`);
          } catch (error) {
            console.error("Error al borrar la imagen antigua:", error);
          }
        }
        // Quitamos el último de la lista
        videosToUpdate.pop();
      }

      // Añadimos el nuevo al principio
      videosToUpdate.unshift(newVideo);

      // Actualizamos Firestore
      const listToUpdate = doc(db, "videosLaLista", listVideosId);
      await updateDoc(listToUpdate, { videos: videosToUpdate });

      alert("Vídeo añadido correctamente");
      navigate("/admin");
      window.location.reload(false);
    } catch (error) {
      console.log("Error creando el vídeo:", error);
      alert("Ha ocurrido un error al crear el vídeo.");
    }
  };

  return (
    <section className="general-container">
      <div className="form-container">
        <form>
          <h3>Crear Vídeo procedente de Youtube</h3>

          <div className="input-container">
            <input value={linkInput} onChange={handleVideoLinkChange} />
            <label className={linkInput && "filled"} htmlFor="link">
              Link
            </label>
          </div>

          <div className="input-container">
            <input value={titleInput} onChange={handleVideoTitleChange} />
            <label className={titleInput && "filled"} htmlFor="title">
              Title
            </label>
          </div>

          <div className="input-container">
            <input value={djInput} onChange={handleVideoDjChange} />
            <label className={djInput && "filled"} htmlFor="dj">
              Dj
            </label>
          </div>

          <div className="uploader-pic">
            <input onChange={handlePictureChange} type="file" name="picture" />
            <label htmlFor="picture">Picture</label>
          </div>

          {isLoadingPicture && <p>...loading picture</p>}

          {pictureURL !== "" ? (
            <img
              src={pictureURL}
              alt="yourPic"
              width={200}
              className="uploader-img"
            />
          ) : (
            <p>[ No Picture Selected ]</p>
          )}

          <button
            type="submit"
            onClick={handleCreateVideo}
            className="general-btn"
          >
            Crear Video
          </button>

          {errorMessage !== "" && (
            <p className="error-message"> * {errorMessage}</p>
          )}
        </form>
      </div>
    </section>
  );
}

export default CreateVideo;
